import { DocumentColumn } from '../document-column';
import { DocumentGrid } from '../document-grid';
import { DocumentList } from '../document-list';

/**
 * The different types of visualizations that are exported by this package.
 *
 * @enum {string}
 */
export const VisualizationType = {
    /**
     * This visualizes an array of Gyda documents as a single column suitable for
     * inclusion in applications and reports in the role of a content stream.
     */
    documentColumn: 'document-column',

    /**
     * This visualizes an array of Gyda documents as a multi-row grid suitable for
     * inclusion in applications and reports.
     */
    documentGrid: 'document-grid',

    /**
     * This visualizes an array of Gyda documents as a single column of compact
     * documents suitable for inclusion in dashboards and reports.
     */
    documentList: 'document-list'
};
Object.freeze(VisualizationType);

/**
 * Retrieve the visualization component for the given visualization type.
 * @param {VisualizationType} visualizationType - The type of visualization to retrieve.
 * @returns {HTMLElement} The visualization component.
 */
export function getVisualization (visualizationType) {
    switch (visualizationType) {
        case VisualizationType.documentColumn:
            return DocumentColumn;
        case VisualizationType.documentGrid:
            return DocumentGrid;
        case VisualizationType.documentList:
            return DocumentList;
        default:
            throw new RangeError(`Parameter must be a valid VisualizationType. Provided value: ${visualizationType}.`);
    }
}

/**
 * Determines if the provided visualization type is valid
 *
 * @name isValidVisualizationType
 * @param {string} visualizationType - The visualization type to validate
 * @returns {boolean} True if the visualization type is valid; otherwise, false
 */
export function isValid (visualizationType) {
    return Object.values(VisualizationType).includes(visualizationType);
}

